import {
  IOnboardingAddressRequest,
  IOnboardingAddressResponse,
  IOnboardingBankRequest,
  IOnboardingBankResponse,
  IOnboardingCreateProfile,
  IOnboardingDocumentRequest,
  IOnboardingUSDBankRequest,
  IOnboardingUSDBankResponse,
} from '@/@types/Onboarding';
import {
  IAcquirerOnboardingResponse,
  IAcquirerOnboardingSingleResponse,
} from '@/@types/AcquirerOnboarding';
import { api } from './api';

async function address(data: IOnboardingAddressRequest) {
  return await api.post<IOnboardingAddressRequest>(
    '/v1/onboarding/address',
    data
  );
}

async function createBankAccount(data: IOnboardingBankRequest) {
  return await api.post<IOnboardingAddressRequest>(
    '/v1/onboarding/bank-account',
    data
  );
}

async function createProfile(data: IOnboardingCreateProfile) {
  return await api.post<IOnboardingCreateProfile>(
    '/v1/onboarding/profile',
    data
  );
}

async function updateProfile(data: IOnboardingCreateProfile) {
  return await api.put<IOnboardingCreateProfile>(
    '/v1/onboarding/profile',
    data
  );
}

async function getAddress() {
  return await api.get<IOnboardingAddressResponse>(`/v1/profile/address`);
}

async function getBanks() {
  const response = await api.get<IOnboardingBankResponse>(
    '/v1/profile/bank-accounts'
  );
  return response.data;
}

async function getInternationalBankAccounts() {
  const response = await api.get<IOnboardingUSDBankResponse>(
    '/v1/usd-bank-accounts'
  );
  return response.data;
}

async function sendDocuments(data: IOnboardingDocumentRequest) {
  return await api
    .post<IOnboardingDocumentRequest>('/v1/onboarding/documents', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      return res;
    });
}

async function resendDocuments(data: IOnboardingDocumentRequest) {
  return await api
    .post<IOnboardingDocumentRequest>('/v1/users/documents', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      return res;
    });
}

async function createInternationalBankAccount(bankData) {
  return await api.post<IOnboardingUSDBankRequest>(
    '/v1/usd-bank-accounts',
    bankData
  );
}

/**
 * Adquirentes do vendedor que usam formulário de KYC hospedado, com o estado de cada uma.
 * A tela renderiza o que vier — não conhece nome de adquirente.
 */
async function getAcquirerOnboardings() {
  const response = await api.get<IAcquirerOnboardingResponse>(
    '/v1/onboarding/acquirer'
  );

  return response.data.data;
}

/**
 * Gera um link novo do formulário. O anterior pode ter expirado ou já ter sido consumido —
 * clientes de mensagem visitam URLs para gerar preview, o que queima link de uso único.
 */
async function refreshAcquirerOnboardingLink(acquirer: string) {
  const response = await api.post<IAcquirerOnboardingSingleResponse>(
    `/v1/onboarding/acquirer/${acquirer}/link`
  );

  return response.data.data;
}

/** Envia os dados pré-KYC. Estando completos, a conta é criada e o link volta no retorno. */
async function submitAcquirerOnboardingFields(
  acquirer: string,
  values: Record<string, unknown>
) {
  const response = await api.post<IAcquirerOnboardingSingleResponse>(
    `/v1/onboarding/acquirer/${acquirer}/fields`,
    { values }
  );

  return response.data.data;
}

export const OnboardingService = {
  getAcquirerOnboardings,
  submitAcquirerOnboardingFields,
  refreshAcquirerOnboardingLink,
  address,
  getAddress,
  createBankAccount,
  createProfile,
  updateProfile,
  sendDocuments,
  getBanks,
  resendDocuments,
  createInternationalBankAccount,
  getInternationalBankAccounts,
};
